import React from "react";
import { Card, HTMLSelect, Icon } from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import CurrentUserStore from "../../stores/CurrentUserStore";
import GoalProgressRow from "../goals/GoalProgressRow.js";

const GoalRatingFormList = ({ goalList = [], finalRating, goalRatings = {}, onRatingChange }) => {
  const accountId = CurrentUserStore?.activeAccount?.accountId ?? null;
  return (
    <Flexbox flexDirection="column">
      <div>
        

        {goalList?.length > 0 &&
          goalList?.map(goal => (
            <Card key={goal.id} style={{ marginBottom: "10px" }}>
              <Flexbox flexDirection="row" alignItems="center" flexGrow={1}>
                <Flexbox flexDirection="row" alignItems="center" flexGrow={1}>
                  <Flexbox style={{ width: "40%", minWidth: "40%", flexShrink: 0 }} flexGrow={1} flexDirection="column">
                    <div>
                      <span className="push-10-r" role="img" aria-label="chart">
                        <Icon icon="settings" style={{ color: "#137CBD" }} />
                      </span>
                      <strong style={{ fontSize: "14px", color: "#333", cursor: "pointer" }}>{goal?.title}</strong>
                    </div>
                  </Flexbox>

                  <Flexbox flexGrow={1} alignItems="center" gap="10px">
                    <span className="push-10-l push-10-r" style={{ fontWeight: "400", color: "#777" }}>
                      Weight: {goal?.goal_weight}
                    </span>

                    <GoalProgressRow goal={goal} accountId={accountId} barWidth="55px" barStyle={{ marginTop: 0 }} />

                    <Flexbox>
                      <HTMLSelect
                        value={goalRatings[goal.id] || ""}
                        onChange={e => {
                          const rating = e.target.value;
                          if (goal.goal_weight !== undefined && goal.goal_weight !== null) {
                            onRatingChange(goal.id, rating, goal.goal_weight);
                          } else {
                            onRatingChange(goal.id, rating);
                          }
                        }}
                        options={[
                          "Select Rating",
                          ...Array.from(
                            { length: goal.goal_rating.end_range - goal.goal_rating.start_range + 1 },
                            (_, i) => goal.goal_rating.start_range + i
                          )
                        ]}
                        style={{ width: "150px" }}
                      />
                    </Flexbox>
                  </Flexbox>
                </Flexbox>
              </Flexbox>
            </Card>
          ))}
      </div>
    </Flexbox>
  );
};

export default GoalRatingFormList;
